"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLabelStyle = exports.useButtonVariantStyle = void 0;
var classnames_1 = require("classnames");
var theme_1 = require("../../../../theme");
var common_utils_1 = require("../../../../tools/common-utils");
var variants = {
    primary: {
        container: 'primary',
        border: 'transparent',
        borderRadius: 'squid-rounded-component-button-border-radius-pill',
    },
    secondary: {
        container: 'secondary',
        border: 'transparent',
        borderRadius: 'squid-rounded-component-button-border-radius-pill',
    },
    success: {
        container: 'success',
        border: 'transparent',
        borderRadius: 'squid-rounded-component-button-border-radius-pill',
    },
    outlined: {
        container: 'base',
        border: {
            default: 'base',
            hover: 'hover:squid-border-alias-color-border-base',
            active: "\n      active:squid-border-alias-color-border-active \n      active:squid-border-alias-border-width-active\n      squid-border-alias-border-width-active\n        ",
        },
        borderRadius: 'squid-rounded-component-button-border-radius-pill',
    },
    'outlined-alt': {
        container: 'base',
        border: {
            default: 'base',
            hover: 'hover:squid-border-alias-color-border-base',
            active: "\n      active:squid-border-alias-color-border-active \n      active:squid-border-alias-border-width-active\n      squid-border-alias-border-width-active\n        ",
        },
        borderRadius: 'squid-rounded-component-button-border-radius-round',
    },
    critical: {
        container: 'destructive',
        border: 'critical',
        borderRadius: 'squid-rounded-component-button-border-radius-pill',
    },
    text: {
        container: 'base',
        border: 'transparent',
        borderRadius: 'squid-rounded-component-button-border-radius-pill',
    },
};
var disabledVariant = {
    container: 'disabled',
    border: 'transparent',
    borderRadius: 'squid-rounded-component-button-border-radius-pill',
};
var labelClassName = {
    primary: {
        color: 'on-primary',
        font: 'squid-text-alias-font-label-strong',
    },
    secondary: {
        color: 'on-secondary',
        font: 'squid-text-alias-font-label-strong',
    },
    success: {
        color: 'on-success',
        font: 'squid-text-alias-font-label-strong',
    },
    disabled: {
        color: 'disabled',
        font: 'squid-text-alias-font-label-strong',
    },
    text: {
        color: 'link-default',
        font: 'squid-text-alias-font-label-strong',
    },
    critical: {
        color: 'on-destructive',
        font: 'squid-text-alias-font-label-strong',
    },
    'outlined-alt': {
        color: 'on-outline',
        font: 'squid-text-alias-font-label-strong',
    },
    outlined: {
        color: 'on-outline',
        font: 'squid-text-alias-font-label-strong',
    },
    active: {
        color: 'on-outline-active',
        font: 'squid-text-alias-font-label-strong',
    },
};
var useButtonVariantStyle = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'primary' : _b, disabled = _a.disabled, active = _a.active, branding = _a.branding, contentStyle = _a.contentStyle;
    var bgColors = (0, theme_1.useBackgroundColors)(branding);
    var bgStateColors = (0, theme_1.useBackgroundStateColors)(branding);
    var borderColors = (0, theme_1.useBorderColors)(branding);
    var ring = (0, theme_1.useRingStyles)(branding);
    if (disabled) {
        var disabledClasses = __assign(__assign({}, disabledVariant), { container: bgColors.disabled });
        if (variant === 'outlined-alt') {
            return (0, common_utils_1.toArray)(__assign(__assign({}, disabledClasses), { borderRadius: variants['outlined-alt'].borderRadius }));
        }
        else if (variant === 'text') {
            return (0, common_utils_1.toArray)(__assign(__assign({}, disabledClasses), { default: 'squid-bg-transparent' }));
        }
        return (0, common_utils_1.toArray)(disabledClasses);
    }
    var _c = variants[variant], border = _c.border, val = __rest(_c, ["border"]);
    var container;
    switch (variant) {
        case 'outlined':
        case 'outlined-alt':
        case 'text':
            container = "".concat(bgColors.transparent, " ").concat(bgStateColors.base);
            break;
        case 'critical':
            container = "".concat(bgColors.transparent, " ").concat(bgStateColors.destructive);
            break;
        default:
            container = "".concat(bgColors[val.container], " ").concat(bgStateColors[val.container]);
            break;
    }
    var borderConfig = {};
    if (border) {
        if (typeof border !== 'string') {
            var _d = border, activeBorder = _d.active, otherBorderProps = __rest(_d, ["active"]);
            borderConfig = active
                ? { activeBorder: (0, classnames_1.default)(activeBorder, borderColors.active) }
                : __assign({ base: borderColors.base }, otherBorderProps);
        }
        else {
            borderConfig = { base: borderColors[border] };
        }
    }
    if (contentStyle === 'light') {
        borderConfig = { default: borderColors.base };
    }
    var variantClasses = __assign(__assign(__assign({}, val), borderConfig), ring);
    return (0, common_utils_1.toArray)(__assign(__assign({}, variantClasses), { container: container }));
};
exports.useButtonVariantStyle = useButtonVariantStyle;
var useLabelStyle = function (_a) {
    var variant = _a.variant, disabled = _a.disabled, active = _a.active, branding = _a.branding, contentStyle = _a.contentStyle;
    var textColors = (0, theme_1.useTextColors)(branding);
    if (disabled) {
        var label_1 = __assign(__assign({}, labelClassName.disabled), { color: textColors[labelClassName.disabled.color] });
        return (0, common_utils_1.toArray)(label_1);
    }
    var label = ['outlined', 'outlined-alt'].includes(variant) && active
        ? labelClassName.active
        : labelClassName[variant];
    return (0, common_utils_1.toArray)(__assign(__assign({}, label), { color: contentStyle === 'base'
            ? textColors[label.color]
            : textColors['on-primary-variant'] }));
};
exports.useLabelStyle = useLabelStyle;
